import { format, parseISO } from "date-fns";

export const formatScheduledDate = (
  scheduledStartAt?: string,
  scheduledEndAt?: string,
): string => {
  if (!scheduledStartAt) return "-";

  const startDateStr = scheduledStartAt.split(" ")[0];
  const startDate = parseISO(startDateStr);
  const formattedStart = format(startDate, "do MMM yyyy");

  if (scheduledEndAt) {
    const endDateStr = scheduledEndAt.split(" ")[0];
    const endDate = parseISO(endDateStr);
    const formattedEnd = format(endDate, "do MMM yyyy");

    return `${formattedStart} - ${formattedEnd}`;
  }

  return formattedStart;
};
